export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask Kripto Para",
            h1B: "MetaMask Kripto Para Bankası",
            h1C: "DeFi Cüzdan Kripto Para",
            h1D: "Coinbase Kripto Para Bankası",
            h1E: "MetaMask Tasarruf Bankası",
            h1F: "Betterment",
            h2: "Arkadaş Davet Et",
            h3: "Çekim Hesabını Bağla",
            h4: "Tasarrufa Katıl",
            h4B: "Kripto Para Yatırımı",
            h4C: "Dijital Para Yükleme",
            h5: "Seçkin Yatırımlar",
            h5B: "Hızlı Kontrat İşlemi",
            h5c: "Yatır",
            h6: "Kullanıcı Havuzu",
            h7: "USDT Hesabı",
            h8: "Toplam Getiri",
            h9: "Geçerli Düğümler",
            h10: "Katılımcılar",
            h11: "Kazanç",
            h12: "Kazanç Kayıtları",
            h13: "Adres",
            h14: "Numara",
            h15: "Sıkça Sorulan Sorular",
            h16: "Nasıl Katılırım?",
            h17: "Değerli kullanıcı, USDT cüzdan tasarrufuna katılmak istiyorsanız, platform kullanıcı kurallarına uymanız, platform kararlarını sıkı bir şekilde uygulamanız ve risk departmanının denetimine tabi olmanız gerekir. Otomatik olarak yatırım izni alacaksınız. Katılımınız için teşekkürler.",
            h17B: "Değerli kullanıcı, USDT cüzdan tasarrufuna katılmak istiyorsanız, platform kullanıcı kurallarına uymanız, platform kararlarını sıkı bir şekilde uygulamanız ve risk departmanının denetimine tabi olmanız gerekir. Otomatik olarak yatırım izni alacaksınız. Katılımınız için teşekkürler.",
            h18: "Para Çekme Nasıl Yapılır?",
            h19: "Günlük kazançlar otomatik olarak hesap bakiyenize eklenir. USDT çekimi başarılı olduğunda, USDT cüzdan hesabınıza otomatik olarak eklenir. Japon Yeni ile çekim yapmak isterseniz, lütfen müşteri hizmetleri ile iletişime geçin. Katılım ve desteğiniz için teşekkürler.",
            h19B: "Günlük kazançlar otomatik olarak hesap bakiyenize eklenir. USDT çekimi başarılı olduğunda, USDT cüzdan hesabınıza otomatik olarak eklenir. Başka bir çekim yöntemi kullanmak isterseniz, lütfen çevrimiçi müşteri hizmetleri ile iletişime geçin!",
            h20: "Kazançlar Nasıl Hesaplanır?",
            h21B: "Dönemsel alımlar ile VIP seviyesine göre kazanç değişir\nVIP1  100u~5000u, Faiz Oranı: %1.8\nVIP2  5000u~20000u, Faiz Oranı: %2.6\nVIP3  20000u~50000u, Faiz Oranı: %3.5\nVIP4  50000u~80000u, Faiz Oranı: %4.7\nVIP5  80000u~120000u, Faiz Oranı: %5.3\nVIP6  120000u~160000u, Faiz Oranı: %6.2\nVIP7  160000u~200000u, Faiz Oranı: %7.3\nVIP8  200000u üzeri, Faiz Oranı: %8\n\n",
            h21: "Başarıyla katıldıktan sonra, tasarruf sözleşmesi kazanç hesaplamaya başlar.",
            h22: "Tasarruf kazancı nereden gelir?",
            h23: "Kullanıcı tasarrufa katıldıktan sonra, tasarruf sözleşmesi geçerli olur. Faiz her gün 00:00 ve 12:00'de iki kez hesaplanır. Tasarruf sözleşmesi geçerli olduktan sonra, fonlar emanet moduna girer ve platform fonların güvenliğinden sorumludur. Hesap güvenliği için platform kurallarına uyun ve sorun varsa çevrimiçi müşteri hizmetleri ile iletişime geçin.",
            h23B: "Kullanıcı tasarrufa katıldıktan sonra, tasarruf sözleşmesi geçerli olur. Faiz her gün 00:00 ve 12:00'de iki kez hesaplanır. Tasarruf sözleşmesi geçerli olduktan sonra, fonlar emanet moduna girer ve platform fonların güvenliğinden sorumludur. Hesap güvenliği için platform kurallarına uyun ve sorun varsa çevrimiçi müşteri hizmetleri ile iletişime geçin.",
            h24: "Bonus Miktarı Ne Kadar?",
            h25: "Platformumu arkadaşlarınızla paylaşabilirsiniz. Arkadaşınız katıldığında, ilk yatırım miktarının %20'si tavsiye bonusu ve gelirlerinin %10'u kalıcı komisyon olarak size verilir. Paylaşım bağlantısı ana sayfanın sağ üst köşesindedir.",
            h25B: "Platformu arkadaşlarınızla paylaşabilirsiniz. Arkadaşınız katıldığında, ilk yatırım miktarının %20'si tavsiye bonusu ve gelirlerinin %10'u kalıcı komisyon olarak size verilir. Paylaşım bağlantısı ana sayfanın sağ üst köşesindedir.",
            h26: "Kullanılabilir Bakiye",
            h27: "Yatırılan Miktar",
        
            h88: "Platform Arka Planı",
            h89: "Betterment\nKuruluş Yılı: 2008\nMerkez: New York, ABD\nPozisyon: Robo-Danışman ve FinTech, otomatik yatırım portföyü ve nakit yönetimi sağlar\nDenetleyici Kurumlar: SEC gözetiminde ve FINRA üyesi\nMüşteri Ölçeği: 40 milyar USD üzerinde yönetilen varlık\nMüşteri Kitlesi: 800.000’den fazla bireysel ve kurumsal müşteri",
            h90: "Platform Avantajları",
            h91: "✔️ ABD'nin ilk Robo-Danışmanı, deneyimli\n✔️ Portföy Modern Varlık Dağılım Teorisine (MPT) dayalı, risk dağıtımı sağlar\n✔️ Vergi optimizasyonu sağlar\n✔️ Yüksek faizli nakit hesapları, likidite güçlü\n✔️ Tam dijital işlem, basit arayüz",
            h92: "Uygun Kullanıcılar",
            h93: "★ Uzun vadeli istikrarlı yatırım yapmak isteyen ve sık işlem yapmak istemeyen kullanıcılar\n★ Otomatik yönetim isteyen, zaman kazandıran genç yatırımcılar\n★ Yatırım + yüksek faizli tasarruf + emeklilik hesabı kullanıcıları\n★ Finansal piyasaya düşük maliyetle girmek isteyen sıradan yatırımcılar",
        
            h28: "Bugünkü Kazanç",
            h29: "Toplam Kazanç",
            h30: "Çekim",
            h31: "Kayıtlar",
            h32: "Kullanılabilir Bakiye",
            h33: "Çekilecek Miktar",
            h34: "Lütfen çekilecek miktarı girin",
            h35: "Hepsi",
            h36: "Çekim",
            h37: "Sıkça Sorulan Sorular",
            h38: "Güvenlik Denetim Raporu",
            h39: "Ortaklar",
            h40: "İş Ortaklarımız",
            h41: "Banka Kartı Numarasını Göster",
            h42: "Önceki Sayfa",
            h43: "Sonraki Sayfa",
            h44: "Bu ilk sayfa",
            h45: "Lütfen çekilecek miktarı girin",
            h46: "Bakiye yetersiz",
            h47: "Bu son sayfa",
            h48: "Gelir",
            h49: "Gider",
            h50: "İşlem çok sık, lütfen daha sonra tekrar deneyin.",
            h51: "Denetim Raporu",
            h52: "Coin Faizi ile Tasarruf",
            h521: "Mevduat Faizi",
            h53: "Sipariş İşlemleri",
            h54: "Kayıt Bonusu",
            h55: "Davet Bonusu",
            h56: "Çekim",
            h57: "Yükleme",
            h58: "Mevduat",
            h59: "Para Çekme",
            h591: "Yatırma Başarılı",
            h592: "Yatırma Başarısız",
            h593: "Bakiye Yetersiz",
            h60: "Kripto Para Transferi ile USDT Hediyesi",
            h61: "MetaMask Bankasını sürekli desteklediğiniz için teşekkürler. Tasarrufu kolaylaştırmak için kripto para (USDT ETH BTC) ile transfer yaparak tasarruf bonusu kazanabilirsiniz. 1000 USDT üzeri yatırımlarda 30 USDT, 5000 USDT üzeri yatırımlarda 200 USDT, 10000 USDT üzeri yatırımlarda her yatırımın %5 bonusu verilir. (Kripto cüzdan ile çekim de aynı avantajı sağlar)",
            h61B: "Coinbase Bankasını desteklediğiniz için teşekkürler. Kripto para (USDT ETH BTC) ile transfer yaparak tasarruf bonusu kazanabilirsiniz. 1000 USDT üzeri yatırımlarda 30 USDT, 5000 USDT üzeri yatırımlarda 200 USDT, 10000 USDT üzeri yatırımlarda her yatırımın %5 bonusu verilir.",
            h61C: "MetaMask Bankasını desteklediğiniz için teşekkürler. Kripto para (USDT ETH BTC) ile transfer yaparak tasarruf bonusu kazanabilirsiniz. 1000 USDT üzeri yatırımlarda 30 USDT, 5000 USDT üzeri yatırımlarda 200 USDT, 10000 USDT üzeri yatırımlarda her yatırımın %5 bonusu verilir.",
            h61D: "Betterment'i desteklediğiniz için teşekkürler. Kripto para (USDT ETH BTC) ile transfer yaparak tasarruf bonusu kazanabilirsiniz. 1000 USDT üzeri yatırımlarda 30 USDT, 5000 USDT üzeri yatırımlarda 200 USDT, 10000 USDT üzeri yatırımlarda her yatırımın %5 bonusu verilir.",
            h62: "Çekim tutarınız {amount}, işlem ücreti %{fee}!",
            h63: "Onayla",
            h99: "Yakında Açılacak",
        },
        bankcard: {
            b1: "Banka Hesabı",
            b2: "Finans Kurumu Adı",
            b3: "Lütfen finans kurumu adını girin",
            b4: "Şube Adı",
            b5: "Lütfen şube adını girin",
            b6: "Şube Numarası",
            b7: "Lütfen şube numarasını girin",
            b8: "Hesap Numarası (Normal)",
            b9: "Lütfen hesap numarasını girin",
            b10: "Takma Ad",
            b11: "Lütfen kullanıcı adını girin",
            b12: "Hesap Sahibi",
            b13: "Lütfen hesap sahibinin adını girin",
            b14: "Bağla",
            b15: "Kripto Para Adresi",
            b16: "Lütfen kripto para adresini girin",
        },
        usdt: {
            u1: "Siparişlerim",
            u2: "Yatır",
            u3: "Lütfen sözleşme süresini seçin:",
            u4: "Alış Fiyatı:",
            u5: "Lütfen yatırılacak miktarı girin",
            u6: "Alışı Arttır",
            u7: "Alışı Azalt",
            u8: "İşlem Başarılı",
            u9: "En az bir miktar"
        },
        order: {
            o0: "Siparişlerim",
            o1: "Sipariş Numarası",
            o2: "Sipariş Türü",
            o3: "Alış Miktarı",
            o4: "Satış Miktarı",
            o5: "Ödeme Miktarı",
            o6: "Sözleşme Süresi",
            o7: "Sipariş Durumu",
            o8: "Hesap Durumu",
            o9: "Hesaplama Zamanı",
            o10: "Sipariş Zamanı",
            o11: "Alışı Arttır",
            o12: "Alışı Azalt",
            o13: "Satıldı",
            o14: "Kâr",
            o15: "Zarar",
            o16: "Ödendi",
            o17: "Başabaş Noktası"
        },
        recharge: {
            r1: "Yükleme Miktarı",
            r2: "Yükleme Tutarı",
            r3: "Yükleme Türü",
            r4: "Lütfen Seçin",
            r5: "Yükleme Adresi",
            r6: "Transfer Sipariş Numarası",
            r7: "Transfer Edildi",
            r8: "İnceleniyor",
            r9: "Yanlış Girdi",
            r10: "Lütfen Ödeme Yöntemi Seçin",
            r11: "Minimum yükleme miktarı",
            r12: "Maksimum yükleme miktarı",
            r13: "Lütfen miktarı girin",
            r14: "Ödeme ekran görüntüsü yükle",
            r15: "Lütfen ödeme ekran görüntüsünü yükleyin",
            r16: "Gönderim Başarılı",
            r17: "İptal",
            r18: "Onayla",
        },
        rechargeDetails: {
            r1: "Yükleme Kayıtları",
            r2: "Yükleme Miktarı",
            r3: "İnceleniyor",
            r4: "Yükleme Başarılı",
            r5: "Yükleme Başarısız"
        },
		cert: {
		    c1: "Kimlik doğrulaması",
		    c2: "Gerçek ad",
		    c21: "Lütfen gerçek adınızı girin",
		    c3: "Doğrulama türü",
		    c31: "Kimlik kartı",
		    c32: "Pasaport",
		    c33: "Ehliyet",
		    c10: "Doğrulama türünü girin",
		    c4: "Belgenin ön yüzü",
		    c41: "Lütfen belgenin ön yüzünü yükleyin",
		    c5: "Belgenin arka yüzü",
		    c51: "Lütfen belgenin arka yüzünü yükleyin",
		    c6: "Gönder",
		    c7: "Başarıyla gönderildi, inceleme bekleniyor...",
		    c8: "Doğrulama onaylandı",
		    c9: "Kimlik doğrulaması başarısız oldu, lütfen tekrar yükleyin",
		    c11: "İnceleniyor",
		    "传入字段不完整": "Eksik alanlar gönderildi",
		    "已认证过": "Zaten doğrulandı",
		    "审核中": "İnceleniyor"
		}
		 }